export const getMobileOperatingSystem = () => {
  if (typeof navigator === 'object' && typeof window === 'object') {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      return 'Android';
    }
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return 'Ios';
    }
  }
  return 'unknown';
};
